import HfReactHelper from 'hellosign/components/hf-react-helper';

const fonts = Object.keys(HfReactHelper.FONT_CHAR_MAP);

export default fonts;
